import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec306ba0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo-container" }
const _hoisted_2 = { class: "right-container" }
const _hoisted_3 = { class: "right-block" }
const _hoisted_4 = {
  "data-wow-duration": "1s",
  class: "techcontext animate__fadeInUp wow"
}
const _hoisted_5 = {
  "data-wow-duration": "1s",
  class: "teamtitle animate__fadeInDown wow"
}
const _hoisted_6 = { class: "span" }
const _hoisted_7 = {
  "data-wow-duration": "1s",
  class: "teamtitle animate__fadeInDown wow"
}
const _hoisted_8 = { class: "span" }
const _hoisted_9 = { class: "left-container" }
const _hoisted_10 = { class: "left-block" }
const _hoisted_11 = {
  "data-wow-duration": "1s",
  class: "teamtitle animate__fadeInDown wow"
}
const _hoisted_12 = {
  "data-wow-duration": "1s",
  class: "techcontext animate__fadeInUp wow"
}
const _hoisted_13 = { class: "span" }
const _hoisted_14 = { class: "span" }

import WOW from 'wowjs'
import { onMounted, ref } from "vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'AboutLogo',
  setup(__props) {

const isHover = ref(false)
onMounted(() => {
  new WOW.WOW(
    { live: false }
  ).init()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t('RE')), 1)
          ]),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('logolefttext')), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t('KEY')), 1)
          ]),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('logorighttext')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('subRekeytitle')), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('meaningRekey')), 1),
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('logobottomtext')), 1)
        ])
      ])
    ])
  ]))
}
}

})